import React from "react";
import { api } from "../../api";
import Cookies from 'universal-cookie';
import { AppIcon } from "../utils/AppIcon";
import { IconButton } from "@mui/material";
import { AppStore } from "../../stores/AppStore";
const cookies = new Cookies()

type Role = "user" | "assistant" | "system";
type Msg = { role: Role; content: string; id: string; time?: string };

function nowTime() {
  const d = new Date();
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

interface State {
  messages: Msg[];
  input: string;
  loading: boolean;
  stage: string;
  intent: null
  showCalcModal: boolean
  filterText: string
  calc: boolean
}

const dialogTree = {
  start: {
    message: "Olá! Escolha uma opção 👇",
    options: [],
  },

  calcGeneral: {
    message: "Sobre qual cálculo você quer conversar?",
    freeInput: true,
  },

  general: {
    message: "Sobre o que deseja conversar?",
    freeInput: true,
  },
};

const menus = [
  { label: "Menu Cálculos", modal: "openCalcModal" },
  { label: "Conversa geral", next: "general" },
]

const calcMenu = [
  { label: "ICMS 1141 - Diferencial de Alíquota", intent: "ICMS_1141" },
  { label: "ICMS 1145 - Antecipado Medicamentos", intent: "ICMS_1145" },
  { label: "ICMS 1146 - Antecipado Entradas", intent: "ICMS_1146" },
  { label: "ICMS 1152 - Cesta Básica", intent: "ICMS_1152" },
  { label: "ICMS 1173 - Antecipado Especial", intent: "ICMS_1173" },
  { label: "ICMS Veterinário PET", intent: "ICMS_PET" },
  { label: "Outros cálculos", next: "calcGeneral" },
  // { label: "Voltar", next: "start" },
]

export default class ChatClass extends React.Component<Record<string, never>, State> {
  private abortCtrl: AbortController | null = null;
  private bottomRef = React.createRef<HTMLDivElement>();

  constructor(props: Record<string, never>) {
    super(props);

    AppStore.setTitle("");

    this.state = {
      messages: [
        {
          id: crypto.randomUUID(),
          role: "assistant",
          content: "Bem-vindo à Fipo AI! como posso ajudar hoje?",
          time: nowTime(),
        },
        {
          id: crypto.randomUUID(),
          role: "assistant",
          content: "Escolha uma opção abaixo 👇",
          time: nowTime(),
        },
      ],
      input: "",
      loading: false,
      stage: "start",
      intent: null,
      showCalcModal: false,
      filterText: "",
      calc: false
    };
  }

  componentDidUpdate() {
    this.bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ intent: null, input: e.target.value });
  };

  stop = () => {
    this.abortCtrl?.abort();
  };

  format_intent(input: string, intent: string) {

    const intentPrompts: Record<string, string> = {
      ICMS_1141: "ICMS 1141 - Diferencial de Alíquota",
      ICMS_1145: "ICMS 1145 - Antecipado Medicamentos",
      ICMS_1146: "ICMS 1146 - Antecipado Entradas",
      ICMS_1152: "ICMS 1152 - Cesta Básica",
      ICMS_1173: "ICMS 1173 - Antecipado Especial",
      ICMS_PET: "ICMS Veterinário PET",
    };

    if (intentPrompts[intent]) {

      return `Como funciona ${intentPrompts[intent]}`;

    }

    return input;

  }

  send = async () => {
    const trimmed = this.state.input.trim();
    if (!trimmed || this.state.loading) return;

    let systemPrompt = this.format_intent(trimmed, this.state.intent)

    const userMsg: Msg = {
      id: crypto.randomUUID(),
      role: "user",
      content: trimmed,
      time: nowTime(),
    };

    // estado otimistico
    const history = [
      ...this.state.messages.filter((m) => m.role !== "system"),
      userMsg,
    ];

    this.setState({ messages: history, input: "", loading: true });

    const controller = new AbortController();
    this.abortCtrl = controller;

    try {

      let resp = await api.post("/api/ai/chat", { input: systemPrompt, calc: this.state.calc });

      const assistantId = crypto.randomUUID();

      this.setState((s) => ({
        messages: [
          ...s.messages,
          { id: assistantId, role: "assistant", content: "", time: nowTime() },
        ],
      }));

      if (resp.status == 401) {

        this.setState((st) => {
          const msgs = [...st.messages];
          msgs[msgs.length - 1] = { id: assistantId, role: "assistant", content: "Você precisa estar logado para utilizar o Chatbot-Fipo." };
          return { messages: msgs };
        });

      } else {

        this.setState((st) => {
          const msgs = [...st.messages];
          msgs[msgs.length - 1] = { id: assistantId, role: "assistant", content: resp.data };
          return { messages: msgs };
        });

      }

    } catch (e) {

      this.setState((s) => ({
        messages: [
          ...s.messages,
          {
            id: crypto.randomUUID(),
            role: "assistant",
            content: "⚠️ Ocorreu um erro ao gerar a resposta.",
            time: nowTime(),
          },
        ],
      }));

    } finally {

      this.abortCtrl = null;

      this.setState({ loading: false });

    }

  };

  onSubmit = (e: React.FormEvent) => {

    e.preventDefault();

    this.send();

  };

  onOptionClick(option) {

    if (option.modal === "openCalcModal") {
      this.setState({ calc: true, filterText: "", showCalcModal: true });
      return;
    }

    if (option.next === "general") {
      this.setState({ calc: false})
    }

    if (option.next) {

      this.setState((s) => ({
        stage: option.next,
        messages: [...s.messages, {
          id: crypto.randomUUID(),
          role: "user",
          content: option.label,
          time: nowTime(),
        }],
        showCalcModal: false
      }));

      this.setState((s) => ({
        stage: option.next,
        messages: [...s.messages, {
          id: crypto.randomUUID(),
          role: "assistant",
          content: dialogTree[option.next].message,
          time: nowTime(),
        }],
        showCalcModal: false
      }));

      return;
    }

    if (option.intent) {
      this.setState({ calc: true, intent: option.intent, input: option.label, showCalcModal: false }, this.send);
    }

  }

  render() {
    const { messages, input, loading } = this.state;

    const stage = dialogTree[this.state.stage];

    return (
      <div className="wa-shell">

        <header className="wa-topbar">
          <div className="wa-avatar" aria-hidden >
            <img src="/images/robot.png" style={{ width: 36, height: 36 }} />
          </div>
          <div className="wa-chatmeta">
            <div className="wa-title">Fipo AI</div>
            <div className="wa-subtitle">online</div>
          </div>
        </header>

        {this.state.showCalcModal && (
          <div className="wa-modal-overlay">
            <div className="wa-modal">
              <div className="wa-modal-header">
                <div>Selecione um cálculo</div>
                <button className="wa-modal-close" onClick={() => this.setState({ showCalcModal: false })}>
                  ✕
                </button>
              </div>

              <div className="wa-search-bar">
                <input
                  type="text"
                  placeholder="Pesquisar cálculo..."
                  value={this.state.filterText}
                  onChange={(e) => this.setState({ filterText: e.target.value })}
                />
              </div>

              <div className="wa-modal-list">
                {calcMenu.filter((o) =>
                  o.label.toLowerCase().includes(this.state.filterText.toLowerCase())
                ).map((o) => (
                  <label key={o.intent} className="wa-radio-row">
                    <input
                      type="radio"
                      name="calcSelect"
                      value={o.intent}
                      onChange={() => this.onOptionClick(o)}
                    />
                    &nbsp;
                    <span>{o.label}</span>
                  </label>

                ))}

                {calcMenu.filter((o) => o.label.toLowerCase().includes(this.state.filterText.toLowerCase())).length === 0 && (
                  <div className="wa-empty">Nenhum cálculo encontrado</div>
                )}

              </div>
            </div>
          </div>
        )}

        <main className="wa-thread">
          {messages.map((m) => (
            <div
              key={m.id}
              className={`wa-bubble ${m.role === "user" ? "from-me" : "from-them"}`}
            >
              <div className="wa-bubble-inner">
                <span className={`${m.role === "user" ? "wa-text-me" : "wa-text-them"}`}>{m.content}</span>
                <span className={`${m.role === "user" ? "wa-time-me" : "wa-time-them"}`}>{m.time}</span>
              </div>
            </div>
          ))}

          {!this.state.loading && (
            <div className="wa-options">
              {menus.map((opt) => (
                <button
                  key={opt.label}
                  className="wa-option-btn"
                  onClick={() => this.onOptionClick(opt)}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          )}
          {loading && (
            <div className="wa-bubble from-them">
              <div className="wa-bubble-inner">
                <span className="wa-text wa-typing">Buscando conhecimento…</span>
              </div>
            </div>
          )}

          <div ref={this.bottomRef} />
        </main>

        <form className="wa-inputbar" onSubmit={this.onSubmit}>
          <input
            className="wa-input"
            placeholder="Pergunte qualquer coisa"
            value={input}
            onChange={this.handleChange}
          />
          {!loading ? (
            <IconButton type="submit" disabled={!input.trim()}><AppIcon name="send" size={30} /></IconButton>
          ) : (
            <IconButton type="submit" disabled><AppIcon name="send" size={30} /></IconButton>
          )}
        </form>
      </div>
    );
  }
}
